var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", d: "M7.5 13.437V2.299c-1.721.73-2.985 1.192-3.859 1.398-.418 2.69-.383 4.688.074 5.967.108.302.381.71.8 1.178.388.437.884.907 1.461 1.397A27.78 27.78 0 0 0 7.5 13.437zm1-.019a27.71 27.71 0 0 0 1.499-1.18 14.84 14.84 0 0 0 1.462-1.396c.417-.468.69-.876.799-1.178.215-.601.32-1.501.319-2.602a24.463 24.463 0 0 0-.182-2.791 29.787 29.787 0 0 0-.074-.578c-.866-.206-2.118-.665-3.823-1.385v11.11zM2.773 2.82c.695 0 2.434-.606 5.214-1.82 2.79 1.214 4.528 1.82 5.215 1.82 0 0 .848 4.803 0 7.18-.738 2.065-5.215 5-5.215 5s-4.476-2.935-5.214-5c-.566-1.585-.566-3.978 0-7.18z" })
  );
});